import { Content, Size, TableCell } from "pdfmake/interfaces";
import { lineColor, primaryColor } from "../../../../consts";
import { GetItemReturnArr } from "../../../../../MainMenu/Panels/SpecificationPanel/SpecificationGeneral";
import { SIDE_MARGINS } from "./getJSONForGeneralSpecification";

export const getPrimarySpecificationTableBodyOneRow = (
    item: GetItemReturnArr,
    isLastRowInSection?: boolean,
    isLastRowInPage?: boolean
): Content => {
    const productTableBody: Content = [];
    const { name, count, price, totalPrice } = item;

    const tableFontSize = 12;
    const border = {
        border: true ? [false, false, false, true] : [false, false, false, false],
        borderColor: [primaryColor, primaryColor, primaryColor, primaryColor],
    };

    const margin = [0, 0, 0, 0];
    const body: Content = {
        color: primaryColor,
        lineHeight: 1,
        margin: [SIDE_MARGINS, 0, SIDE_MARGINS, 0],
        ...(isLastRowInPage ? { pageBreak: "after" } : {}),
        table: {
            widths: ["*", 100],
            heights: 13,
            body: [
                [
                    {
                        ...border,
                        text: name,
                        alignment: "left",
                        fontSize: tableFontSize,
                        margin,
                    },
                    {
                        ...border,
                        alignment: "center",
                        text: `${count} шт.`,
                        fontSize: tableFontSize,
                        bold: false,
                        margin,
                    },
                ],
            ],
        },
        layout: {
            paddingTop: () => {
                return 0;
            },
            paddingBottom: () => {
                return 0;
            },
            hLineColor: function (i, node) {
                return lineColor;
            },
            vLineColor: function (i, node) {
                return lineColor;
            },
        },
    };

    productTableBody.push(body);

    return productTableBody;
};
